export default "__VITE_ASSET__CKhmqkAW__"